import React  from 'react';
import { basename } from '../locale';

export const MarkenGrid = (props) => {
    // function Marke(props){
    //     return <div className='col-sm-6 col-md-4 col-lg-4 no-padding-mobile'>
    //         <div className='portfolio-item'>
    //             <div className='hover-bg'>
    //                 {' '}
    //                 <a
    //                     href={"/maschinen?hersteller="+ props.hersteller}
    //                     // title='Project Title'
    //                     data-lightbox-gallery='gallery1'
    //                 >
    //                     <div className='hover-text'>
    //                     </div>
    //                     <img
    //                         src={'img/marken/' + props.img}
    //                         className='img-responsive gallery-img'
    //                         alt={props.hersteller}
    //                     />{' '}
    //                 </a>{' '}
    //             </div>
    //         </div>
    //     </div>;
    // }
    function Marke(props) {
        return <div className="logo-box col-sm-6 col-md-4 col-lg-4 no-padding-mobile">
            <a href={basename + "/suche?suchtext=" + props.hersteller} >
                <img
                    src={'img/marken/' + props.img}
                    className='img-responsive gallery-img'
                    alt={props.hersteller} />
            </a>
        </div>
    }
    return (
        <div className='row'>
            <Marke img="abac.webp" hersteller="Abac"></Marke>
            <Marke img="altendorf.webp" hersteller="Altendorf"></Marke>
            <Marke img="balma.webp" hersteller="Balma"></Marke>
            <Marke img="barth.webp" hersteller="Barth"></Marke>
            <Marke img="bessey.webp" hersteller="Bessey"></Marke>
            <Marke img="casadei.webp" hersteller="Casadei"></Marke>
            <Marke img="centauro.webp" hersteller="Centauro"></Marke>
            <Marke img="dewalt.webp" hersteller="Dewalt"></Marke>
            <Marke img="duo_fast.webp" hersteller="Duo Fast"></Marke>
            <Marke img="elcon.webp" hersteller="Elcon"></Marke>
            <Marke img="fein.webp" hersteller="Fein"></Marke>
            <Marke img="fervi.webp" hersteller="Fervi"></Marke>
            <Marke img="fisch_tools.webp" hersteller="Fisch Tools"></Marke>
            <Marke img="formec.webp" hersteller="Formec"></Marke>
            <Marke img="hess.webp" hersteller="Hess"></Marke>
            <Marke img="hm_muellner.webp" hersteller="HM Müllner"></Marke>
            <Marke img="hoefer_presstechnik.webp" hersteller="Höfer Presstechnick"></Marke>
            <Marke img="holz_her.webp" hersteller="Holz Her"></Marke>
            <Marke img="knapp_verbinder.webp" hersteller="Knapp"></Marke>
            <Marke img="kundig.webp" hersteller="Kundig"></Marke>
            <Marke img="kuper.webp" hersteller="Kuper"></Marke>
            <Marke img="lft.webp" hersteller="LFT"></Marke>
            <Marke img="maggi.webp" hersteller="maggi"></Marke>
            <Marke img="makita.webp" hersteller="Makita"></Marke>
            <Marke img="minimax.webp" hersteller="minimax"></Marke>
            <Marke img="morbidelli.webp" hersteller="morbidelli"></Marke>
            <Marke img="nestro.webp" hersteller="Nestro"></Marke>
            <Marke img="omc.webp" hersteller="OMC"></Marke>
            <Marke img="omga.webp" hersteller="Omga"></Marke>
            <Marke img="putsch_meniconi.webp" hersteller="Putsch"></Marke>
            <Marke img="renner.webp" hersteller="Renner Kompressoren"></Marke>
            <Marke img="scm.webp" hersteller="SCM"></Marke>
            <Marke img="sicar.webp" hersteller="Sicar"></Marke>
            <Marke img="stehle.webp" hersteller="Stehle"></Marke>
            <Marke img="stromab.webp" hersteller="Stromab"></Marke>
            <Marke img="stubai.webp" hersteller="Stubai"></Marke>
            <Marke img="tormek.webp" hersteller="Tormek"></Marke>
            <Marke img="ulmia.webp" hersteller="Ulmia"></Marke>
        </div>
    )
}